import { ItemWithTranslation, SportsFavoritesMenuManifestazioneDto, SportsSottoVoceMenu } from 'types/swagger';

import { Item as Accordion } from '@radix-ui/react-accordion';
import { SportNavAccordionContent } from './components/sportNavAccordionContent';
import { SportNavAccordionTrigger } from './components/sportNavAccordionTrigger';
import styles from './SportNavAccordion.module.scss';
import { useTranslation } from 'hooks/useLingUI';

export type SportNavAccordionProps = ItemWithTranslation<{ descrizione?: string }> & {
  uid?: string;
  iconSrc?: string;
  manifestazioni: Array<SportsFavoritesMenuManifestazioneDto | SportsSottoVoceMenu>;
};

export const SportNavAccordion = ({
  uid,
  iconSrc,
  manifestazioni,
  descrizione,
  descrizioneTrKey,
}: SportNavAccordionProps) => {
  const { t } = useTranslation();
  return (
    <Accordion className={styles.item} value={descrizione ?? ''} data-uid={uid}>
      <SportNavAccordionTrigger
        aria-label={t(descrizioneTrKey, descrizione)}
        text={descrizione ?? ''}
        textTrKey={descrizioneTrKey}
        iconSrc={iconSrc ? iconSrc : ''}
      />
      <SportNavAccordionContent manifestazioni={manifestazioni} />
    </Accordion>
  );
};
